





























import { Vue, Component, Prop } from 'vue-property-decorator';
import Comment from '@/model/Comment';
import * as firebase from 'firebase/app';
import User from '@/model/User';
import { COLLECTION_NOTIFICATIONS, COLLECTION_ORGANIZATIONS, COLLECTION_POSTS, COLLECTION_USERS } from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import NotificationType from '@/model/typelist/NotificationType';
import Notification from '@/model/Notification';

@Component({
  components: {
  },
})
export default class CommentComponent extends Vue {
  @Prop({ type: Object }) readonly post!: string;

  defaultComment = {
    createdOn: '',
    text: '',
    userId: '',
  };

  comment = { ...{}, ...this.defaultComment };

  addComment(post: any) {
    const postObj = { ...post };
    postObj.id = post.id;
    postObj.createdBy = FirebaseUtil.ObjectToRef(COLLECTION_USERS, post.createdBy.uid);
    const postCmts = [] as any;
    post.comments.forEach((cmt: any) => {
      const cmtObj = { ...cmt };
      cmtObj.createdTime = cmt.createdTime;
      cmtObj.createdBy = FirebaseUtil.ObjectToRef(COLLECTION_USERS, cmt.createdBy.uid);
      cmtObj.text = cmt.text;
      postCmts.push(cmtObj);
    });
    postObj.comments = postCmts;
    const cmtObj = new Comment(this.comment.text,
      FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.$store.state.currentUser.uid));
    postObj.comments.push({ ...cmtObj });
    if (post.organization) {
      postObj.organization = FirebaseUtil
        .ObjectToRef(COLLECTION_ORGANIZATIONS, post.organization.id);
    }
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_POSTS,
      doc: post.id,
      payload: postObj,
    });
    this.$store.dispatch('addToCollection', {
      collection: COLLECTION_NOTIFICATIONS,
      payload: { ...this.parsedNotification(post) },
    });
    this.comment.text = '';
  }

  parsedNotification(post: any) {
    const notiObj = new Notification();
    notiObj.type = { ...NotificationType.comment };
    notiObj.initiatedBy = FirebaseUtil.ObjectToRef(
      COLLECTION_USERS,
      this.currentUser.uid,
    );
    notiObj.to = FirebaseUtil.ObjectToRef(
      COLLECTION_USERS,
      post.createdBy.uid,
    );
    notiObj.data = FirebaseUtil.ObjectToRef(
      COLLECTION_POSTS,
      post.id,
    );
    return notiObj;
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }
}
